
var winWidth = $(window).width();

if ( $('.circles--item').length > 0 && winWidth < 992 ) {

	$('.circles--item').on('click', function(e) {

		e.preventDefault();
		$(this).toggleClass('is-flipped');

	});

}
